import { render, staticRenderFns } from "./ResponsesPreview.vue?vue&type=template&id=6ec18646&"
import script from "./ResponsesPreview.vue?vue&type=script&lang=js&"
export * from "./ResponsesPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports